















































import { Component, Vue, Prop } from "vue-property-decorator";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});

@Component({
  name: "BankInfo",
  components: {
    ValidationProvider
  }
})
export default class BankInfo extends Vue {
  @Prop() readonly bankField!: number;
  @Prop() id!: number;
  @Prop() showRemove!: boolean;

  public BankAccTypes = [
    { value: "IBA", text: "IBA" },
    { value: "INT", text: "INT" },
  ];
  public CurrencyList = [
    { value: "EUR", text: "EUR" },
    { value: "USD", text: "USD" },
  ];
  removeBank(idx: any) {
    this.$emit("remove", idx);
  }
}
